module.exports = __webpack_public_path__ + "static/media/12575940_994976757249693_2125711764_n.32a0da81.jpg";